<div class="ordered-list">
  <ol class="ordered-list__list">
    <li class="ordered-list__list-item" *ngFor="let block of block.content; trackBy: trackByFn;" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></li>
  </ol>
</div>
